import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAreaTypeOptions } from 'api/areaTypes';
import { AreaType } from 'interfaces/areaType';

export const useAreaTypes = (
  params?: Omit<UseQueryOptions<AreaType[], unknown, AreaType[], string[]>, 'queryKey' | 'queryFn'>
) => {
  return useQuery(['areaTypes'], () => getAreaTypeOptions(), params);
};
